import { BaseService, Service } from "/@/cool";

@Service("dealerPackageSettlement")
class DealerPackageSettlement extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["delete"] = prefix + "delete";
		this.permission["batchSave"] = prefix + "batchSave";
	}

	list(params: any) {
		return this.request({
			url: "/list",
			method: "GET",
			params
		});
	}

	page(params: any) {
		return this.request({
			url: "/page",
			method: "GET",
			params
		});
	}

	info(params: any) {
		return this.request({
			url: "/info",
			method: "GET",
			params
		});
	}

	add(data: any) {
		return this.request({
			url: "/add",
			method: "POST",
			data
		});
	}

	update(data: any) {
		return this.request({
			url: "/update",
			method: "POST",
			data
		});
	}

	delete(data: any) {
		return this.request({
			url: "/delete",
			method: "POST",
			data
		});
	}

	batchSave(data: any) {
		return this.request({
			url: "/batchSave",
			method: "POST",
			data
		});
	}
}

export default DealerPackageSettlement;
